import { Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import { DynamicHtml } from "@/components/DynamicHtml";
import Blob from "./Blob.svg";

export default function Delivery({ className, url_slug }) {
  return (
    <div className={clsx(className, classes.delivery)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Row>
          <Col xs={12} md={6}>
            <DynamicText path={`page.case.study.${url_slug}.delivery.title`} tag="h2" className="mb-5">
              The Delivery
            </DynamicText>
            <DynamicHtml path={`page.case.study.${url_slug}.delivery.text`}>
              <p>
                <strong>Training Schedule</strong>
              </p>
              <p>
                A six-week window was allocated to deliver training. Training courses were scheduled, delegates booked,
                and mapped to staff rotas. With an agreed 80% trained level, training was applied to each business area,
                ward, and outpatient department, not just as a blanket across the whole organisation.
              </p>
              <p>
                <strong>Floor Walking Process and Support</strong>
              </p>
              <p>
                All trainers were rolled over into floor-walking roles as the project went live. Initial support of 1
                floorwalker per ward, outpatient, and administrative department was reduced as users became more
                familiar with the system and processes.
              </p>
            </DynamicHtml>
          </Col>
          <Col xs={12} md={6}>
            <div className={classes.delivery__statistic}>
              <Blob />
              <dl>
                <dd>
                  <DynamicText path={`page.case.study.${url_slug}.delivery.statistic`}>80%</DynamicText>
                </dd>
                <dt>
                  <DynamicText path={`page.case.study.${url_slug}.delivery.statistic.label`}>
                    Training Level
                  </DynamicText>
                </dt>
              </dl>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
